import React from 'react';

export const InlineErrorMsg = ({msg}) => {
  return (
    <div className="fv-plugins-message-container">
      <div className="fv-help-block">{msg}</div>
    </div>
  )
}